import React, { ReactNode, useEffect } from 'react';
import styled, { css } from 'styled-components';
import { theme, toRem } from 'design';
import { Sidebar } from '../Sidebar';

interface ILayoutSidebarProps {
  content: ReactNode;
  fixedMobile?: boolean;
  sidebar: ReactNode;
  sidebarOpen?: boolean; // for mobile, default to false
  className?: string;
}

const Layout = styled.div<Partial<ILayoutSidebarProps>>`
  position: relative;
  display: flex;
  flex: 1;
  flex-flow: column nowrap;
  width: 100%;
  height: auto;

  ${({ fixedMobile }) =>
    fixedMobile &&
    css`
      flex-flow: row nowrap;
      justify-content: flex-start;
      align-items: flex-start;
      height: 100%;
    `}

  @media (min-width: ${theme.breakpoint.large}px) {
    flex-flow: row nowrap;
    justify-content: flex-start;
    align-items: flex-start;
    height: 100%;
  }
`;

const Content = styled.section`
  position: relative;
  display: flex;
  flex-grow: 1;
  flex-flow: column nowrap;
  justify-content: flex-start;
  align-items: flex-start;
  width: 100%;
  height: auto;
  padding-bottom: ${toRem(theme.header.height)};

  @media (min-width: ${theme.breakpoint.large}px) {
    padding-right: ${toRem(theme.sidebar.width.large)};
    padding-bottom: 0;
  }

  @media (min-width: ${theme.breakpoint.xlarge}px) {
    padding-right: ${toRem(theme.sidebar.width.xlarge)};
  }
`;

const LayoutSidebar = ({ className, content, fixedMobile = true, sidebar, sidebarOpen = false, ...rest }: ILayoutSidebarProps) => {
  useEffect(() => {
    if (fixedMobile) {
      document.body.classList.toggle('prevent-scroll', sidebarOpen);
    }
    return () => document.body.classList.toggle('prevent-scroll', false);
  }, [fixedMobile, sidebarOpen]);

  return (
    <Layout fixedMobile={fixedMobile} className={className} {...rest}>
      <Content className="content">{content}</Content>
      <Sidebar fixedMobile={fixedMobile} isOpen={sidebarOpen}>
        {sidebar}
      </Sidebar>
    </Layout>
  );
};

export default LayoutSidebar;
